import { waitForMs } from 'framework/utils/async-utils';
import { setCss } from 'js/crossword/html/setCSS';

declare const sgSettings;

type Color = string;

export interface ICustomisationOptions {
  mainUIColor: Color | null;
  selectedSquareHighlightColor: Color | null;
  buttonBackgroundColor: Color | null;
  buttonTextColor: Color | null;
  fontUrl: string | null;
  fontFamily: string | null;
  disablePrint: boolean;
  disableCalendar: boolean;
  disableHelp: boolean;
  disableTimer: boolean;
  disableAutocheck: boolean;
  cellCorrectFontColor: Color | null;
  cellRevealedFontColor: Color | null;
  scrollBarHeadColor: Color | null;
  scrollBarBackgroundColor: Color | null;
  secondClueColor: Color | null;
}

const defaultOptions: ICustomisationOptions = {
  mainUIColor: '#e3e9ff',
  selectedSquareHighlightColor: '#fed92e',
  buttonBackgroundColor: '#3E5FD7',
  buttonTextColor: '#FFFFFF',
  fontUrl: null,
  fontFamily: 'Arial',
  disablePrint: false,
  disableCalendar: false,
  disableHelp: false,
  disableTimer: false,
  disableAutocheck: true,
  cellCorrectFontColor: '#0000ff',
  cellRevealedFontColor: '#889fef',
  scrollBarHeadColor: '#889fef',
  scrollBarBackgroundColor: '#c4c4c4',
  secondClueColor: '#3E5FD7',
};

export function getCustomisationOptions(): ICustomisationOptions {
  const result = { ...defaultOptions };

  Object.entries(sgSettings.config.crossword.customisation).forEach(([key, value]) => {
    if (value !== null) result[key] = value;
  });

  return result;
}

export async function applyCustomisationOptionsToViewSettings(): Promise<void> {
  const options = getCustomisationOptions();
  if (options.fontUrl && options.fontFamily) {
    loadGoogleFont(options.fontUrl, options.fontFamily);
  }
  setCss();
}

export async function loadGoogleFont(googleFontUrl: string, familyName: string): Promise<void> {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = googleFontUrl;
  document.head.appendChild(link);

  let promise: Promise<void> = waitForMs(1000) as Promise<void>;

  if (document.fonts) {
    promise = new Promise((resolve) => {
      document.fonts.onloadingdone = () => {
        console.warn('on loading done');
        document.fonts.onloadingdone = null;
        resolve();
      };
    });
  }

  const div = document.createElement('div');
  div.innerText = '1';
  div.style.fontFamily = familyName;
  div.style.position = 'absolute';
  div.style.top = '-999px';
  document.body.appendChild(div);

  return promise;
}
